module.exports = __webpack_public_path__ + "static/media/image_step1.f46ec29c.png";